import { render, staticRenderFns } from "./PanelGroupComponent.vue?vue&type=template&id=b9c218fc&"
import script from "./PanelGroupComponent.vue?vue&type=script&lang=js&"
export * from "./PanelGroupComponent.vue?vue&type=script&lang=js&"
import style0 from "./PanelGroupComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports